import { useCallback, useEffect } from 'react';
import { useMe } from '@/account/profile/api';
import { useHasAccessToken } from '@/auth/api';
import { ONESIGNAL_APP_ID, WORKSPACE } from '@/base/constants';
import { useSettings } from '@/settings/api';
import { oneSignal } from './oneSignal';

const isEnabled = !!ONESIGNAL_APP_ID && WORKSPACE === 'app';

export const useOneSignal = () => {
  const hasAccessToken = useHasAccessToken();
  const me = useMe();
  const [settings] = useSettings();

  const initOneSignal = useCallback(async () => {
    await oneSignal.init();
    await oneSignal.setLanguage(settings.language);
  }, [settings.language]);

  useEffect(() => {
    if (isEnabled) {
      initOneSignal();
    }
  }, [initOneSignal]);

  const handleSetExternalId = useCallback(async () => {
    if (!isEnabled) return;
    if (hasAccessToken && me?.data?.key) {
      await oneSignal.setExternalId(me.data.key, me?.data?.email || undefined);
    } else if (!hasAccessToken) {
      await oneSignal.setExternalId();
    }
  }, [hasAccessToken, me.data]);

  useEffect(() => {
    handleSetExternalId();
  }, [handleSetExternalId]);

  return isEnabled ? oneSignal : null;
};
